document.addEventListener('DOMContentLoaded', () => {
  const reviewsSection = document.querySelector('.reviews-section');
  
  if (!reviewsSection) return;
  
  const reviewsDataAttr = reviewsSection.dataset.reviewsData;
  const starsContainer = reviewsSection.querySelector('.reviews-section__stars');
  const ratingElement = reviewsSection.querySelector('.reviews-section__rating-number');
  const countElement = reviewsSection.querySelector('.reviews-section__count-number');
  const recommendedPercentageElement = reviewsSection.querySelector('.reviews-section__recommended-percentage');
  const secondaryRatingsContainer = reviewsSection.querySelector('.reviews-section__secondary-ratings');
  const sortDisplay = reviewsSection.querySelector('#sort-display');
  const sortDropdown = reviewsSection.querySelector('#sort-dropdown');
  const reviewsList = reviewsSection.querySelector('.reviews-section__list');
  const loadingElement = reviewsSection.querySelector('.reviews-section__loading');
  const errorElement = reviewsSection.querySelector('.reviews-section__error');
  const paginationContainer = reviewsSection.querySelector('.reviews-section__pagination');
  
  let reviewsData = null;
  let currentSort = 'most-relevant';
  let currentPage = 1;
  const reviewsPerPage = 3;
  
  // Initialize sort dropdown functionality
  initializeSortDropdown();
  
  // Initialize sort dropdown
  function initializeSortDropdown() {
    if (!sortDisplay || !sortDropdown) return;
    
    // Handle sort display click
    sortDisplay.addEventListener('click', (e) => {
      e.preventDefault();
      toggleSortDropdown();
    });
    
    // Handle keyboard for sort display
    sortDisplay.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleSortDropdown();
      } else if (e.key === 'Escape') {
        closeSortDropdown();
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        openSortDropdown();
        // Focus first option
        const firstOption = sortDropdown.querySelector('.sort-option');
        if (firstOption) firstOption.focus();
      }
    });

    // Handle sort option clicks
    const sortOptions = sortDropdown.querySelectorAll('.sort-option');
    sortOptions.forEach(option => {
      option.addEventListener('click', (e) => {
        selectSortOption(option);
      });
      
      // Handle keyboard navigation
      option.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectSortOption(option);
        } else if (e.key === 'Escape') {
          closeSortDropdown();
          sortDisplay.focus();
        } else if (e.key === 'ArrowDown') {
          e.preventDefault();
          focusNextOption(option);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          focusPreviousOption(option);
        }
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!sortDisplay.contains(e.target) && !sortDropdown.contains(e.target)) {
        closeSortDropdown();
      }
    });
  }
  
  function selectSortOption(option) {
    const value = option.getAttribute('data-value');
    const label = option.textContent.trim();
    
    // Update display
    const placeholder = sortDisplay.querySelector('.placeholder');
    if (placeholder) {
      placeholder.textContent = label;
    }
    
    // Update current sort, reset to first page, and re-render reviews
    currentSort = value;
    currentPage = 1;
    renderReviews();
    closeSortDropdown();
  }
  
  function focusNextOption(currentOption) {
    const options = Array.from(sortDropdown.querySelectorAll('.sort-option'));
    const currentIndex = options.indexOf(currentOption);
    const nextIndex = (currentIndex + 1) % options.length;
    options[nextIndex].focus();
  }
  
  function focusPreviousOption(currentOption) {
    const options = Array.from(sortDropdown.querySelectorAll('.sort-option'));
    const currentIndex = options.indexOf(currentOption);
    const prevIndex = currentIndex === 0 ? options.length - 1 : currentIndex - 1;
    options[prevIndex].focus();
  }

  function toggleSortDropdown() {
    const isActive = sortDropdown.classList.contains('active');
    if (isActive) {
      closeSortDropdown();
    } else {
      openSortDropdown();
    }
  }

  function openSortDropdown() {
    sortDropdown.classList.add('active');
    sortDropdown.setAttribute('aria-hidden', 'false');
    sortDropdown.removeAttribute("hidden");
    sortDisplay.classList.add('active');
    sortDisplay.setAttribute('aria-expanded', 'true');
  }

  function closeSortDropdown() {
    sortDropdown.classList.remove('active');
    sortDropdown.setAttribute('aria-hidden', 'true');
    sortDropdown.setAttribute("hidden", "");
    sortDisplay.classList.remove('active');
    sortDisplay.setAttribute('aria-expanded', 'false');
  }

  
  // Show loading state
  function showLoading() {
    loadingElement.style.display = 'block';
    errorElement.style.display = 'none';
    reviewsList.style.opacity = '0.5';
  }
  
  // Hide loading state
  function hideLoading() {
    loadingElement.style.display = 'none';
    reviewsList.style.opacity = '1';
  }
  
  // Show error state
  function showError() {
    hideLoading();
    errorElement.style.display = 'block';
  }
  
  // Create secondary ratings HTML
  function createSecondaryRatingsHTML(secondaryRatings) {
    if (!secondaryRatings || !Array.isArray(secondaryRatings)) return '';
    
    // Filter for the specific ratings we want to display
    const targetLabels = ['Display Quality', 'Battery Life', 'Value'];
    const filteredRatings = secondaryRatings.filter(rating => 
      targetLabels.includes(rating.label)
    );

    if (filteredRatings.length === 0) return '';
    
    return filteredRatings.map(rating => `
      <div class="reviews-section__secondary-rating">
        <div class="reviews-section__secondary-stars">
            ${createStarsHTML(rating.rating)}
          </div>
          <span class="reviews-section__secondary-rating-number">${rating.rating.toFixed(1)}</span>
          <span class="reviews-section__secondary-label">${rating.label}</span>
      </div>
    `).join('');
  }
  
  // Create stars HTML for ratings (single star for secondary ratings)
  function createStarsHTML(rating) {
    // Only show 1 star for secondary ratings, similar to review-item__header
    const fullStarSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.66309 16.1335C3.49443 16.1335 3.32576 16.0815 3.18109 15.9795C2.90709 15.7855 2.77643 15.4475 2.84909 15.1195L3.86309 10.5422L0.618427 6.88682C0.397761 6.63749 0.345094 6.29482 0.481761 5.99149C0.617761 5.68882 0.909094 5.50015 1.24176 5.50015H5.50509L7.23509 1.50682C7.36776 1.20216 7.66776 1.00482 7.99976 1.00482C8.33176 1.00482 8.63243 1.20216 8.76443 1.50682H8.76509L10.4951 5.50015H14.7584C15.0911 5.50015 15.3824 5.68815 15.5184 5.99149C15.6551 6.29482 15.6031 6.63749 15.3824 6.88615L12.1371 10.5415L13.1504 15.1195C13.2224 15.4475 13.0924 15.7855 12.8184 15.9795C12.5451 16.1735 12.1831 16.1848 11.8971 16.0075L7.99976 13.5888L4.10243 16.0082C3.96776 16.0915 3.81509 16.1335 3.66309 16.1335Z" fill="#C37600"></path>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99964 12.5583C8.15164 12.5583 8.30364 12.6003 8.4403 12.685L12.0883 14.949L11.1056 10.5083C11.071 10.3523 11.113 10.1883 11.2196 10.0683L14.3876 6.50029H10.3856C10.0523 6.50029 9.75231 6.30296 9.62031 5.99762L7.99964 2.25696L6.37897 5.99829C6.24697 6.30296 5.94697 6.50029 5.6143 6.50029H1.6123L4.7803 10.069C4.8863 10.189 4.92897 10.353 4.8943 10.509L3.91097 14.949L7.5603 12.6843C7.69564 12.6003 7.84764 12.5583 7.99964 12.5583Z" fill="#A89500"></path>
    </svg>`;
    
    return `<span class="reviews__star reviews__star--full">${fullStarSVG}</span>`;
  }
  
  // Update star display based on rating
  function updateStars(rating) {
    const stars = starsContainer.querySelectorAll('.reviews__star');
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    
    stars.forEach((star, index) => {
      const starSvg = star.querySelector('svg');
      
      if (index < fullStars) {
        // Full star
        star.classList.add('reviews__star--full');
        star.classList.remove('reviews__star--half', 'reviews__star--empty');
      } else if (index === fullStars && hasHalfStar) {
        // Half star
        star.classList.add('reviews__star--half');
        star.classList.remove('reviews__star--full', 'reviews__star--empty');
        starSvg.outerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
                d="M7.99989 12.5579C8.15189 12.5579 8.30389 12.5999 8.43989 12.6846L12.0886 14.9492L11.0499 10.2592L14.3879 6.49991H10.3852C10.0526 6.49991 9.75256 6.30258 9.62056 5.99724L7.99989 2.25724L6.37856 5.99791C6.24722 6.30258 5.94722 6.49991 5.61456 6.49991H1.61189L4.94922 10.2599L3.91122 14.9492L7.56056 12.6839C7.69589 12.5999 7.84789 12.5579 7.99989 12.5579ZM3.66322 16.1332C3.49389 16.1332 3.32522 16.0812 3.18122 15.9792C2.90656 15.7852 2.77656 15.4472 2.84922 15.1192L3.86256 10.5426L0.617889 6.88658C0.397223 6.63791 0.345223 6.29458 0.481223 5.99124C0.617889 5.68858 0.909223 5.49991 1.24122 5.49991H5.50456L7.23522 1.50658C7.36789 1.20191 7.66789 1.00458 7.99989 1.00458C8.33189 1.00458 8.63189 1.20191 8.76389 1.50658H8.76456L10.4946 5.49991H14.7586C15.0912 5.49991 15.3819 5.68791 15.5179 5.99124C15.6546 6.29458 15.6026 6.63724 15.3819 6.88658L12.1372 10.5419L13.1506 15.1192C13.2226 15.4472 13.0926 15.7852 12.8186 15.9792C12.5446 16.1732 12.1826 16.1846 11.8972 16.0072L7.99989 13.5886L4.10256 16.0079C3.96722 16.0912 3.81522 16.1332 3.66322 16.1332Z"
                fill="#C4C8CF"/>
          <mask id="mask0_1827_89" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="9" height="17">
            <rect y="0.5" width="8.5" height="16" fill="white"/>
          </mask>
          <g mask="url(#mask0_1827_89)">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M3.66309 16.1335C3.49443 16.1335 3.32576 16.0815 3.18109 15.9795C2.90709 15.7855 2.77643 15.4475 2.84909 15.1195L3.86309 10.5422L0.618427 6.88682C0.397761 6.63749 0.345094 6.29482 0.481761 5.99149C0.617761 5.68882 0.909094 5.50015 1.24176 5.50015H5.50509L7.23509 1.50682C7.36776 1.20216 7.66776 1.00482 7.99976 1.00482C8.33176 1.00482 8.63243 1.20216 8.76443 1.50682H8.76509L10.4951 5.50015H14.7584C15.0911 5.50015 15.3824 5.68815 15.5184 5.99149C15.6551 6.29482 15.6031 6.63749 15.3824 6.88615L12.1371 10.5415L13.1504 15.1195C13.2224 15.4475 13.0924 15.7855 12.8184 15.9795C12.5451 16.1735 12.1831 16.1848 11.8971 16.0075L7.99976 13.5888L4.10243 16.0082C3.96776 16.0915 3.81509 16.1335 3.66309 16.1335Z"
                  fill="#C37600"/>
          </g>
          <mask id="mask1_1827_89" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="8" height="17">
            <rect y="0.5" width="7.5" height="16" fill="white"/>
          </mask>
          <g mask="url(#mask1_1827_89)">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M7.99964 12.5583C8.15164 12.5583 8.30364 12.6003 8.4403 12.685L12.0883 14.949L11.1056 10.5083C11.071 10.3523 11.113 10.1883 11.2196 10.0683L14.3876 6.50029H10.3856C10.0523 6.50029 9.75231 6.30296 9.62031 5.99762L7.99964 2.25696L6.37897 5.99829C6.24697 6.30296 5.94697 6.50029 5.6143 6.50029H1.6123L4.7803 10.069C4.8863 10.189 4.92897 10.353 4.8943 10.509L3.91097 14.949L7.5603 12.6843C7.69564 12.6003 7.84764 12.5583 7.99964 12.5583Z"
                  fill="#A89500"/>
          </g>
        </svg>`;
      } else {
        // Empty star
        star.classList.add('reviews__star--empty');
        star.classList.remove('reviews__star--full', 'reviews__star--half');
        starSvg.outerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99964 12.5583C8.15164 12.5583 8.30364 12.6003 8.4403 12.685L12.0883 14.949L11.1056 10.5083C11.071 10.3523 11.113 10.1883 11.2196 10.0683L14.3876 6.50029H10.3856C10.0523 6.50029 9.75231 6.30296 9.62031 5.99762L7.99964 2.25696L6.37897 5.99829C6.24697 6.30296 5.94697 6.50029 5.6143 6.50029H1.6123L4.7803 10.069C4.8863 10.189 4.92897 10.353 4.8943 10.509L3.91097 14.949L7.5603 12.6843C7.69564 12.6003 7.84764 12.5583 7.99964 12.5583Z" fill="none" stroke="#E5E5E5" stroke-width="1"/>
        </svg>`;
      }
    });
    
    starsContainer.dataset.rating = rating.toFixed(1);
  }
  
  // Format date for display
  function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }
  
  // Create individual review HTML
  function createReviewHTML(review) {
    const fullStarSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd"
            d="M3.66309 16.1335C3.49443 16.1335 3.32576 16.0815 3.18109 15.9795C2.90709 15.7855 2.77643 15.4475 2.84909 15.1195L3.86309 10.5422L0.618427 6.88682C0.397761 6.63749 0.345094 6.29482 0.481761 5.99149C0.617761 5.68882 0.909094 5.50015 1.24176 5.50015H5.50509L7.23509 1.50682C7.36776 1.20216 7.66776 1.00482 7.99976 1.00482C8.33176 1.00482 8.63243 1.20216 8.76443 1.50682H8.76509L10.4951 5.50015H14.7584C15.0911 5.50015 15.3824 5.68815 15.5184 5.99149C15.6551 6.29482 15.6031 6.63749 15.3824 6.88615L12.1371 10.5415L13.1504 15.1195C13.2224 15.4475 13.0924 15.7855 12.8184 15.9795C12.5451 16.1735 12.1831 16.1848 11.8971 16.0075L7.99976 13.5888L4.10243 16.0082C3.96776 16.0915 3.81509 16.1335 3.66309 16.1335Z"
            fill="#C37600"/>
      <path fill-rule="evenodd" clip-rule="evenodd"
            d="M7.99964 12.5583C8.15164 12.5583 8.30364 12.6003 8.4403 12.685L12.0883 14.949L11.1056 10.5083C11.071 10.3523 11.113 10.1883 11.2196 10.0683L14.3876 6.50029H10.3856C10.0523 6.50029 9.75231 6.30296 9.62031 5.99762L7.99964 2.25696L6.37897 5.99829C6.24697 6.30296 5.94697 6.50029 5.6143 6.50029H1.6123L4.7803 10.069C4.8863 10.189 4.92897 10.353 4.8943 10.509L3.91097 14.949L7.5603 12.6843C7.69564 12.6003 7.84764 12.5583 7.99964 12.5583Z"
            fill="#A89500"/>
    </svg>`;
    
    const emptyStarSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99964 12.5583C8.15164 12.5583 8.30364 12.6003 8.4403 12.685L12.0883 14.949L11.1056 10.5083C11.071 10.3523 11.113 10.1883 11.2196 10.0683L14.3876 6.50029H10.3856C10.0523 6.50029 9.75231 6.30296 9.62031 5.99762L7.99964 2.25696L6.37897 5.99829C6.24697 6.30296 5.94697 6.50029 5.6143 6.50029H1.6123L4.7803 10.069C4.8863 10.189 4.92897 10.353 4.8943 10.509L3.91097 14.949L7.5603 12.6843C7.69564 12.6003 7.84764 12.5583 7.99964 12.5583Z" fill="none" stroke="#E5E5E5" stroke-width="1"/>
    </svg>`;
    
    const stars = Array.from({length: 1}, (_, i) => {
      const starSVG = i < review.rating ? fullStarSVG : emptyStarSVG;
      const starClass = i < review.rating ? 'reviews__star--full' : 'reviews__star--empty';
      return `<span class="reviews__star ${starClass}">${starSVG}</span>`;
    }).join('');
    
    return `
      <div class="review-item">
        <h3 class="review-item__title">${review.title}</h3>
        <div class="review-item__header">
          <div class="review-item__stars">
            ${stars}
          </div>
          <div class="review-item__rating">${review.rating}.0</div>
        </div>
        <div class="review-item__content">
          <p>${review.content}</p>
        </div>
        <div class="review-item__meta">
          <span class="review-item__author">by ${review.userDisplayName}, </span>
          <span class="review-item__date">${formatDate(review.submissionDate)}</span>
        </div>
      </div>
    `;
  }
  
  // Sort reviews based on selected option
  function sortReviews(reviews, sortType) {
    const sortedReviews = [...reviews];
    
    switch (sortType) {
      case 'most-recent':
        return sortedReviews.sort((a, b) => new Date(b.submissionDate) - new Date(a.submissionDate));
      case 'oldest':
        return sortedReviews.sort((a, b) => new Date(a.submissionDate) - new Date(b.submissionDate));
      case 'highest-rating':
        return sortedReviews.sort((a, b) => b.rating - a.rating);
      case 'lowest-rating':
        return sortedReviews.sort((a, b) => a.rating - b.rating);
      case 'most-relevant':
      default:
        // For most relevant, return the original order from the metafield
        return sortedReviews;
    }
  }
  
  // Render reviews list with pagination
  function renderReviews() {
    if (!reviewsData || !reviewsData.reviews || reviewsData.reviews.length === 0) {
      reviewsList.innerHTML = '<p class="reviews-section__no-reviews">No reviews available.</p>';
      renderPagination(0);
      return;
    }
    
    const sortedReviews = sortReviews(reviewsData.reviews, currentSort);
    const totalReviews = sortedReviews.length;
    const totalPages = Math.ceil(totalReviews / reviewsPerPage);
    
    // Calculate start and end indices for current page
    const startIndex = (currentPage - 1) * reviewsPerPage;
    const endIndex = startIndex + reviewsPerPage;
    const currentPageReviews = sortedReviews.slice(startIndex, endIndex);
    
    // Render current page reviews
    const reviewsHTML = currentPageReviews.map(review => createReviewHTML(review)).join('');
    reviewsList.innerHTML = reviewsHTML;
    
    // Render pagination controls
    renderPagination(totalPages);
  }
  
  // Process reviews from metafield data
  function processReviews() {
    if (!reviewsDataAttr) {
      showError();
      return;
    }
    
    showLoading();
    
    try {
      // Parse the JSON data from the metafield
      reviewsData = JSON.parse(reviewsDataAttr);
      
      // Handle case where metafield might be empty or null
      if (!reviewsData) {
        countElement.textContent = '0';
        ratingElement.textContent = '0.0';
        updateStars(0);
        renderReviews();
        hideLoading();
        return;
      }
      
      // Check if reviews array exists and is valid
      if (!reviewsData.reviews || !Array.isArray(reviewsData.reviews)) {
        countElement.textContent = '0';
        ratingElement.textContent = '0.0';
        updateStars(0);
        renderReviews();
        hideLoading();
        return;
      }
      
      // Use provided averageRating and reviewCount
      const averageRating = reviewsData.averageRating || 0;
      const totalReviews = reviewsData.reviewCount || (reviewsData.reviews ? reviewsData.reviews.length : 0);
      const recommendedPercentage = reviewsData.recommendedPercentage || 0;
      
      // Update UI
      countElement.textContent = totalReviews;
      ratingElement.textContent = averageRating.toFixed(1);
      updateStars(averageRating);
      
      // Update recommended percentage
      if (recommendedPercentageElement) {
        recommendedPercentageElement.textContent = recommendedPercentage + '%';
      }
      
      // Update secondary ratings (Display Quality, Battery Life, Value)
      if (secondaryRatingsContainer && reviewsData.secondaryRatings) {
        secondaryRatingsContainer.innerHTML = createSecondaryRatingsHTML(reviewsData.secondaryRatings);
      }
      
      // Render reviews
      renderReviews();
      
      hideLoading();
      
    } catch (error) {
      console.error('Error processing reviews:', error);
      showError();
    }
  }
  
  // Create pagination HTML
  function createPaginationHTML(totalPages) {
    if (totalPages <= 1) return '';
    
    let paginationHTML = '<div class="reviews-pagination">';
    
    // Previous button
    const prevDisabled = currentPage === 1 ? ' disabled' : '';
    const prevIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
      <path d="M6 1L2 5L6 9" stroke="#030303" stroke-width="2" stroke-linecap="round"/>
    </svg>`;
    paginationHTML += `<button class="reviews-pagination__btn reviews-pagination__prev${prevDisabled}" data-page="${currentPage - 1}" aria-label="Go to previous reviews page">${prevIcon}</button>`;
    
    // Page numbers with ellipsis logic
    paginationHTML += '<div class="reviews-pagination__pages">';
    
    if (totalPages <= 5) {
      // Show all pages if 5 or fewer
      for (let i = 1; i <= totalPages; i++) {
        const activeClass = i === currentPage ? ' active' : '';
        const ariaLabel = i === currentPage ? `Current page, page ${i}` : `Go to reviews page ${i}`;
        paginationHTML += `<button class="reviews-pagination__page${activeClass}" data-page="${i}" aria-label="${ariaLabel}">${i}</button>`;
      }
    } else {
      // Always show 2 pages on each side of current page
      let startPage = Math.max(1, currentPage - 2);
      let endPage = Math.min(totalPages, currentPage + 2);
      
      // Adjust range to always show 5 pages when possible
      if (endPage - startPage < 4) {
        if (startPage === 1) {
          endPage = Math.min(totalPages, startPage + 4);
        } else if (endPage === totalPages) {
          startPage = Math.max(1, endPage - 4);
        }
      }
      
      // Show ellipsis at the beginning if needed
      if (startPage > 1) {
        paginationHTML += '<span class="reviews-pagination__ellipsis">...</span>';
      }
      
      // Show the page range
      for (let i = startPage; i <= endPage; i++) {
        const activeClass = i === currentPage ? ' active' : '';
        const ariaLabel = i === currentPage ? `Current page, page ${i}` : `Go to page ${i}`;
        paginationHTML += `<button class="reviews-pagination__page${activeClass}" data-page="${i}" aria-label="${ariaLabel}">${i}</button>`;
      }
      
      // Show ellipsis at the end if needed
      if (endPage < totalPages) {
        paginationHTML += '<span class="reviews-pagination__ellipsis">...</span>';
      }
    }
    
    paginationHTML += '</div>';
    
    // Next button
    const nextDisabled = currentPage === totalPages ? ' disabled' : '';
    const nextIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none" style="transform: rotate(180deg);">
      <path d="M6 1L2 5L6 9" stroke="#030303" stroke-width="2" stroke-linecap="round"/>
    </svg>`;
    paginationHTML += `<button class="reviews-pagination__btn reviews-pagination__next${nextDisabled}" data-page="${currentPage + 1}" aria-label="Go to next reviews page">${nextIcon}</button>`;
    
    paginationHTML += '</div>';
    return paginationHTML;
  }
  
  // Render pagination controls
  function renderPagination(totalPages) {
    if (!paginationContainer) return;
    
    const paginationHTML = createPaginationHTML(totalPages);
    paginationContainer.innerHTML = paginationHTML;
    
    // Add event listeners to pagination buttons
    const paginationButtons = paginationContainer.querySelectorAll('button:not(.disabled)');
    paginationButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const page = parseInt(button.dataset.page);
        if (page && page !== currentPage) {
          currentPage = page;
          renderReviews();
          
          // Scroll to top of reviews section
          reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }
  
  // Initialize reviews section
  processReviews();
});
